import axios from '../utils/axios';

export default function getSeekerList (adminId, params) {
    return axios.get(`/admin/${adminId}/get-seeker-list`, { params });
}